import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithBackground.js";
import MainFeature1 from "components/features/TwoColWithButton.js";
import Features from "components/features/ThreeColSimple.js";

import DesignIllustration from "images/design-illustration-2.svg";
import PrototypeIllustration from "images/prototype-illustration.svg";
import TeamIllustration from "images/team-illustration-2.svg";
import SupportIconImage from "images/support-icon.svg";
import ShieldIconImage from "images/shield-icon.svg";
import CustomerLoveIconImage from "images/simple-icon.svg";

const Subheading = tw.span`uppercase tracking-wider text-sm`;

export default () => {
  return (
    <AnimationRevealPage>
      <Header />
      <MainFeature1
        subheading={<Subheading>About Spurnest</Subheading>}
        heading="Building software that makes a difference."
        imageSrc={DesignIllustration}
        description={
          <span>
            Founded in 2021 by <strong>Hardik Suthar</strong> and <strong>Gautam Prajapati</strong>, Spurnest Techlabs is headquartered in Gandhinagar, India. We started with a simple mission: help businesses and entrepreneurs turn their ideas into reliable, production-ready software.
            <br /><br />
            From students launching their first app to enterprises scaling complex platforms, we bring the same passion and technical depth to every project we take on.
          </span>
        }
      />
      <MainFeature1
        subheading={<Subheading>Our Vision</Subheading>}
        heading="Your vision, our engineering."
        imageSrc={PrototypeIllustration}
        textOnLeft={false}
        description="We don't believe in one-size-fits-all solutions. Every product we build starts with understanding your goals, your users, and your market. We combine modern technology with thoughtful design to deliver software that actually solves problems — not just checks boxes."
      />
      <MainFeature1
        subheading={<Subheading>Our Team</Subheading>}
        heading="Experienced founders, dedicated developers."
        imageSrc={TeamIllustration}
        description={
          <span>
            <strong>Hardik Suthar</strong> — Co-founder & Lead Developer, specializing in full-stack web and mobile development.
            <br /><br />
            <strong>Gautam Prajapati</strong> — Co-founder & Technical Lead, focused on architecture, IoT, and scalable backend systems.
            <br /><br />
            Our growing team covers design, development, testing, and deployment — ready to join your project from day one. <a href="/contact-us" tw="text-primary-500 font-semibold">Get in touch</a> to hire dedicated developers.
          </span>
        }
      />
      <Features
        subheading={<Subheading>Our Values</Subheading>}
        heading="What drives us every day."
        description=""
        cards={[
          {
            imageSrc: SupportIconImage,
            title: "24/7 Support",
            description: "Round-the-clock assistance from our professional team — we're here whenever you need us."
          },
          {
            imageSrc: ShieldIconImage,
            title: "Strong Teams",
            description: "Experienced developers and designers who bring deep expertise to every line of code."
          },
          {
            imageSrc: CustomerLoveIconImage,
            title: "Customer Satisfaction",
            description: "Your success is our success. We iterate until the product meets your expectations."
          },
        ]}
        linkText=""
      />
      <Footer />
    </AnimationRevealPage>
  );
};
